module.exports = __webpack_public_path__ + "img/open_app_icon2.30cdf10e.png";